<div class="container-fluid mt-4">

  @if (createProjectForm.controls['projectName'].errors?.invalidName) {
    <div class="alert alert-danger alert-dismissible fade show" role="alert">
      <ul class="mb-0">
        <li>The Project Name cannot contain any of the following special characters / \ : * ? " > |.</li>
      </ul>
    </div>
  }
  @if (createProjectForm.controls['projectName'].errors?.minlength) {
    <div class="alert alert-danger alert-dismissible fade show" role="alert">
      <ul class="mb-0">
        <li>The Project Name must have a minimum of 5 characters and cannot exceed 100 characters.</li>
      </ul>
    </div>
  }

  @if (createProjectFormSubmitted && (createProjectForm.invalid || (isDGRelated && !selectedDrillGroup))) {
    <div class="alert alert-danger alert-dismissible fade show" role="alert">
      @if (createProjectForm.invalid) {
        <ul class="mb-0">
          <li [hidden]="createProjectForm.controls['projectName'].valid">A Project Name is required with a minimum of 5 characters and a maximum of 69, excluding special characters / \ : * ? " > |.</li>
          <li [hidden]="createProjectForm.controls['ExploreDevelopIds'].valid">Explore / Develop must be selected.</li>
          <li [hidden]="createProjectForm.controls['ProjectTypeIds'].valid">A Project Type must be selected.</li>
          <li [hidden]="createProjectForm.controls['ProjectSubTypeIds'].valid">A Project Sub Type must be selected.</li>
          <li [hidden]="createProjectForm.controls['ConstructionTypeIds'].valid">A Construction Type must be selected.</li>
          <li [hidden]="createProjectForm.controls['AfeApprovalTeam'].valid">A WBS Approval Team must be selected.</li>
          @if (showStartDate){
            <li [hidden]="createProjectForm.controls['StartDate'].valid">A Project Start date is required.</li>
          }
          <li [hidden]="createProjectForm.controls['NeedByDate'].valid && !createProjectForm.controls['NeedByDate'].hasError('dateMustBeGreaterThanStart')">A Project Finish date is required and must exceed the Project Start date.</li>
          <li [hidden]="createProjectForm.controls['WellIds'].valid || !showWellSelectors">A Well selection is required for this Project Type.</li>
          <li [hidden]="!createProjectForm.controls['Name']?.errors?.invalidCharacters">Special characters are not allowed.</li>
          @if (selectedProjectType === ProjectTypeId.TankBattery) {
            <li [hidden]="createProjectForm.controls['BatteryDesignTypes'].valid">A Battery Design Type must be selected.</li>
          }
        </ul>
      }
      @if (isDGRelated && !selectedDrillGroup) {
        <ul class="mb-0">
          <li>A Drill Group must be selected from the grid.</li>
        </ul>
      }
    </div>
  }
  <form [formGroup]="createProjectForm" (ngSubmit)="AddNewProject(null);">
    <button type="submit" style="display:none;">Submit</button>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="ProjectTypeIds">Project Type</label>
          <kendo-combobox id="ProjectTypeIds" formControlName="ProjectTypeIds" class="form-control" [data]="DataSources.ProjectTypeIds"
            [disabledControl]="!(fieldVisibility.ProjectTypeIds)" [textField]="'name'" [valueField]="'value'" [placeholder]="'Select Project Type...'"
            [clearButton]="false">
          </kendo-combobox>
        </div>
      </div>
      <div class="col-md-1">
        @if (this.showCreateProjectsForWellsInGroup || this.showPostStimCheckbox) {
          <label style="line-height: 22px;">Auto Create Projects</label>
        }
        @if (this.showCreateProjectsForWellsInGroup) {
          <div class="form-group form-check">
            <input id="createWellProjectsFromGroup" formControlName="CreateProjectsForWellsInGroup" class="form-check-input checkbox-parameters" type="checkbox">
            <label class="form-check-label" for="createWellProjectsFromGroup" style="line-height: 22px;">All Wells in Group</label>
          </div>
        }
        @if (this.showPostStimCheckbox) {
          <div class="form-group form-check">
            <input id="wellassignedtoexistingpod" formControlName="CreatePostStimProject"
              class="form-check-input checkbox-parameters" type="checkbox">
            <label class="form-check-label" for="wellassignedtoexistingpod" style="line-height: 22px;">Post Stim</label>
          </div>
        }
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="ProjectSubTypeIds">Project Sub Type</label>
          <kendo-combobox id="ProjectSubTypeIds" formControlName="ProjectSubTypeIds" class="form-control" [data]="DataSources.ProjectSubTypeIds"
            [disabledControl]="!(areThereSubtypes && selectedProjectType)" [textField]="'name'" [valueField]="'value'" [placeholder]="'Select Project Sub Type...'"
            [clearButton]="false" [itemDisabled]="projectSubTypeItemDisabled">
          </kendo-combobox>
        </div>
      </div>
      <div [hidden]="isPadConstructionProject" class="col-md-4">
        <div class="form-group">
          <label for="ConstructionTypeIds">Construction Type</label>
          <kendo-combobox id="ConstructionTypeIds" formControlName="ConstructionTypeIds" class="form-control" [data]="this.specialDataSources.ConstructionType.filtered"
            [disabledControl]="isPadConstructionProject" [textField]="'name'" [valueField]="'value'" [placeholder]="'Select Construction Type ...'"
            [clearButton]="true">
          </kendo-combobox>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="WellIdsCombo">Well</label>
          <kendo-combobox #WellIdsCombo id="WellIdsCombo" class="form-control" [data]="dAssetWells" [textField]="'AssetName'" [valueField]="'AssetId'"
            [placeholder]="'Select Well...'" [disabledControl]="!showWellSelectors"
            [clearButton]="true" formControlName="WellIds" [filterable]="true" (valueChange)="handleAssetsWellSelectChange($event)">
          </kendo-combobox>
        </div>
      </div>
      <div [hidden]="isPadConstructionProject" class="col-md-4">
        <div class="form-group">
          <label for="DgIdsCombo">Drill Group</label>
          <kendo-combobox #DgIdsCombo id="DgIdsCombo" class="form-control" [data]="dDrillGroups" [textField]="'Description'" [valueField]="'DrillGroupId'"
            [placeholder]="'Select Drill Group...'" [disabledControl]="!showDrillGroups" [clearButton]="true" formControlName="DrillGroupIds" [filterable]="true" (valueChange)="handleDrillGroupFilter($event)">
          </kendo-combobox>
        </div>
      </div>
      <div [hidden]="!isPadConstructionProject" class="col-md-4">
        <div class="form-group">
          <label for="ConstructionSequenceIds">Construction Sub Type</label>
          <kendo-combobox id="ConstructionSequenceIds" formControlName="ConstructionSequenceIds" class="form-control" [data]="this.specialDataSources.ConstructionSequence.filtered"
            [disabledControl]="!isPadConstructionProject" [textField]="'name'" [valueField]="'value'" [placeholder]="'Select Sub Construction Type ...'"
            [clearButton]="true">
          </kendo-combobox>
        </div>
      </div>
      <div [hidden]="hideTankBattery" class="col-md-4">
        <div class="form-group">
          <label for="TankBatteryAssetId">Tank Battery</label>
          <kendo-combobox #TbIdsCombo id="TankBatteryAssetId" formControlName="TankBatteryAssetId" class="form-control" [data]="dTBAssets" [textField]="'AssetName'" [valueField]="'AssetId'"
            [placeholder]="'Select Tank Battery Asset...'" [clearButton]="true" [disabled]="selectedProjectType != 1" [filterable]="true" (valueChange)="handleTankBatteryAssetsFilter($event)" (selectionChange)="tbAssetselectionChange($event)">
          </kendo-combobox>
        </div>
      </div>
      <div [hidden]="hidePPID" class="col-md-4">
        <div class="form-group">
          <label for="PadAssetId">PPID</label>
          <kendo-combobox #PPIDsCombo id="PadAssetId" formControlName="PadAssetId" class="form-control" [data]="dPPIDs" [textField]="'AssetName'" [valueField]="'AssetId'"
            [placeholder]="'Select PPID...'" [clearButton]="true" [disabled]="selectedProjectType != 1" [filterable]="true" (valueChange)="handlePPIDAssetsFilter($event)">
          </kendo-combobox>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="projectName">Project Name</label>
          <div class="flex-row">
            <input id="projectName" class="k-textbox form-control" formControlName="projectName" placeholder="Enter Project Name..."
              [disabledControl]="!(fieldVisibility.projectName)" maxlength="100">
            <div style="line-height: 30px;margin-left: 10px;">{{69 - createProjectForm.controls['projectName'].value.length}} chars @if (createProjectForm.controls['projectName'].value.length > 0) {
                <span>left</span>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="ExploreDevelopIds">Explore / Develop</label>
          <kendo-combobox id="ExploreDevelopIds" formControlName="ExploreDevelopIds" class="form-control" [data]="OtherDataSources.ExploreDevelopIds" [textField]="'name'"
            [disabledControl]="!(fieldVisibility.ExploreDevelopIds)" [valueField]="'value'" [placeholder]="'Select Explore / Develop'" [clearButton]="false">
          </kendo-combobox>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="AfeApprovalTeam">WBS Approval Team
            @if (approvalTeamUrl) {
              <a style="text-decoration-line: underline" [href]="approvalTeamUrl" target="_blank">(view approvers for selected)</a>
            }
          </label>
          <div style="display: flex; gap: 8px;">
            <kendo-combobox id="AfeApprovalTeam" formControlName="AfeApprovalTeam" class="form-control" [data]="AfeApprovalTeamsFiltered" [textField]="'ProjectTeam'"
              [valueField]="'ProjectTeam'" [placeholder]="'Select WBS Approval Team...'" [clearButton]="false"
              [filterable]="true"
              (filterChange)="handleFilter($event, this.AfeApprovalTeamsData, 'AfeApprovalTeamsFiltered', 'ProjectTeam')"
              (valueChange)="handleAfeApprovalTeamChange($event)">
            </kendo-combobox>
            <button type="button" class="refresh-icon" kendoButton themeColor="primary" [buttonLoading]="refreshClicked" [svgIcon]="icons.refresh" [disabled]="refreshClicked" (click)="refreshAFEApprovalTeams(true)">Refresh</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
    </div>
    <hr />
    <br />
    <div class="row">
      @if (selectedProjectType === ProjectTypeId.TankBattery) {
        <div class="col-md-4">
          <div class="form-group">
            <label for="BatteryDesignTypeIds">Battery Design Type</label>
            <kendo-combobox id="BatteryDesignTypeIds" formControlName="BatteryDesignTypes" class="form-control" [data]="BatteryDesignTypes" [textField]="'Description'" [valueField]="'BatteryDesignTypeId'" [placeholder]="'Select Battery Design Type...'"
              [clearButton]="false">
            </kendo-combobox>
          </div>
        </div>
      }
      @else {
        <div class="col-md-4">
        </div>
      }
      <div class="col-md-4">
        <div class="form-group">
          <label for="StartDate">Project Start</label>
          <kendo-datepicker id="StartDate" #StartDate formControlName="StartDate" class="prelabel" class="form-control" (blur)="onProjectStartEndDateBlur()"
            [disabledControl]="!(showStartDate)"></kendo-datepicker>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="NeedByDate">Project Finish</label>
          <kendo-datepicker id="NeedByDate" #NeedByDate formControlName="NeedByDate" class="prelabel" class="form-control" [min]="createProjectForm.controls['StartDate'].value"
            [disabledControl]="!(showFinishDate)" (blur)="onProjectStartEndDateBlur()">
          </kendo-datepicker>
        </div>
      </div>
    </div>
    @if (isFalseNonOperating) {
      <div>
        @if (fieldVisibility.BusinessAssociateIds) {
          <div class="dp-label">BusinessAssociate</div>
        }
        <kendo-combobox formControlName="BusinessAssociateIds" class="cem-kd-combo2" style="width:90%" [data]="OtherDataSources.BusinessAssociateIds"
          [disabledControl]="" [textField]="'name'" [valueField]="'value'" [placeholder]="'Select BusinessAssociate...'" [clearButton]="false">
        </kendo-combobox>
      </div>
    }
  </form>
</div>
@if (selectedProjectType == 1 && selectedProjectSubType) {
  <div class="flex-column">
    <div>
      <app-project-asset-mapping-tank-battery (tankBatteryAssets)="updateTBAssets($event)" [assetTeamId]="selectedAssetTeam" [projectTypeId]="selectedProjectType"
        [preSelectedAssets]="preSelectedAssets" [scenarioId]="selectedScenario" [projectSubType]="selectedProjectSubType" [notifyTBAssetChange]="notifyTBAssetChange" (clearTBAsset)="clearTBAsset($event)"> </app-project-asset-mapping-tank-battery>
    </div>
  </div>
}
@if (selectedProjectType == 19 || selectedProjectType == 60) {
  <div class="flex-column">
    <div>
      <app-project-asset-mapping-pipeline (pipelineAssets)="updatePipelineAssets($event)" [projectTypeId]="selectedProjectType"></app-project-asset-mapping-pipeline>
    </div>
  </div>
}
@if ((selectedProjectType == 57 && selectedProjectSubTypeId) || selectedProjectType == 61 || selectedProjectType == 62) {
  <div class="flex-column">
    <div>
      <app-project-drill-group-mapping [projectTypeId]="selectedProjectType" [projectSubTypeId]="selectedProjectSubTypeId" (rowSelected)="handleRowSelected($event)"></app-project-drill-group-mapping>
    </div>
  </div>
}